import {
    useTable,
    List,
} from "@refinedev/antd";
import { Table, Button, Tooltip, theme } from "antd";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { Link } from "@refinedev/core";

dayjs.extend(relativeTime);

export const ConcentratorList = () => {
    const { token } = theme.useToken();
    const { tableProps } = useTable({
        syncWithLocation: true,
    });

    return (
        <List>
            <Table {...tableProps} rowKey="id">
                <Table.Column dataIndex="name" title="Name" />
                <Table.Column
                    dataIndex="last_seen"
                    title="Last Seen"
                    sorter
                    render={(value: any) => {
                        if (!value) {
                            return <span style={{ color: token.colorTextTertiary }}>Never</span>;
                        }
                        const relativeTime = dayjs(value).fromNow();
                        const exactTime = dayjs(value).format('YYYY-MM-DD HH:mm:ss');
                        return (
                            <Tooltip title={exactTime}>
                                <span style={{ cursor: 'help' }}>{relativeTime}</span>
                            </Tooltip>
                        );
                    }}
                />
                <Table.Column
                    dataIndex="meters"
                    title="Meters"
                    render={(_, record: any) => (
                        <Link to={`/concentrators/${record.id}/meters/electricity/current`}>
                            <Button size="small" type="primary">
                                View Meters
                            </Button>
                        </Link>
                    )}
                />
                <Table.Column
                    dataIndex="remote"
                    title="Remote Access"
                    render={(_, record: any) => {
                        const hasAccess = record.remote_access_role && record.remote_access_role !== "none";
                        const host = record.remote_host || null;
                        const scheme = typeof window !== "undefined" && window.location?.protocol ? window.location.protocol : "https:";
                        const href = host ? `${scheme}//${host}/` : undefined;
                        return (
                            <Button
                                size="small"
                                href={hasAccess ? href : undefined}
                                target="_blank"
                                disabled={!hasAccess || !href}
                            >
                                Open Remote
                            </Button>
                        );
                    }}
                />
                {/* <Table.Column dataIndex="customer" title="Customer" />
                <Table.Column dataIndex="url" title="URL" />
                <Table.Column dataIndex="uuid" title="UUID" />
                <Table.Column 
                    dataIndex="created_at" 
                    title="Created At"
                    render={(value: any) => <DateField value={value} />}
                />
                <Table.Column 
                    dataIndex="updated_at" 
                    title="Updated At"
                    render={(value: any) => <DateField value={value} />}
                />
                <Table.Column dataIndex="customer_name" title="Customer Name" />
                <Table.Column
                    title="Actions"
                    dataIndex="actions"
                    render={(_, record: any) => (
                        <Space>
                            <EditButton hideText recordItemId={record.id} />
                            <ShowButton hideText recordItemId={record.id} />
                            <DeleteButton hideText recordItemId={record.id} />
                        </Space>
                    )}
                /> */}
            </Table>
        </List>
    );
};
